import {AxiosError} from 'axios';

import {
    AlertMetadataDTO,
    AlertTypeDTO,
    Completable,
    CreditMonitoringDetailDTO,
    KashableResponseDTO,
} from 'kashable-mobile-common';

import {AlertSelectOption} from '../hooks/useAlerts';
import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

const DEFAULT_LENGTH = 10;

export enum ProductType {
    ALL = 'ALL',
    CREDIT_MONITORING = 'CREDIT_MONITORING',
    LOAN = 'LOAN',
}

const getCreditReports: () => Promise<Completable<CreditMonitoringDetailDTO>> = () => {
    return axios
        .get<KashableResponseDTO<CreditMonitoringDetailDTO>>('/secured/user/monitoring')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const getCreditReportByDate: (reportDt: Date) => Promise<Completable<CreditMonitoringDetailDTO>> = (
    reportDt: Date,
) => {
    return axios
        .get<KashableResponseDTO<CreditMonitoringDetailDTO>>('/secured/user/monitoring', {params: {reportDt}})
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const getNotificationsMetadata: (productType?: ProductType) => Promise<Completable<AlertMetadataDTO>> = (productType?: ProductType) => {
    const params = { p: productType || ProductType.ALL };

    return axios
        .get<KashableResponseDTO<AlertMetadataDTO>>('/secured/user/product/notification/metadata', { params })
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const getNotifications: (
    length?: number,
    offset?: number,
    type?: AlertSelectOption,
    productType?: ProductType,
) => Promise<Completable<AlertTypeDTO[]>> = (length?: number, offset?: number, type?: AlertSelectOption, productType?: ProductType) => {
    const params = { l: length || DEFAULT_LENGTH, o: offset || 0, t: type || AlertSelectOption.ALL, p: productType || ProductType.ALL };

    return axios
        .get<KashableResponseDTO<AlertTypeDTO[]>>('/secured/user/product/notification', { params })
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const getNotificationDetails: (gid: string) => Promise<Completable<AlertTypeDTO>> = (gid: string) => {
    const url = `/secured/user/product/notification/${gid}`;

    return axios
        .get<KashableResponseDTO<AlertTypeDTO>>(url)
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const readNotification: (gidArr: number[]) => Promise<Completable<AlertTypeDTO[]>> = (gidArr: number[]) => {
    return axios
        .post<KashableResponseDTO<AlertTypeDTO[]>>('/secured/user/product/notification/read', {
            value: gidArr,
        })
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

// TODO: for development
const clearNotification: () => Promise<Completable<AlertTypeDTO[]>> = () => {
    return axios
        .delete<KashableResponseDTO<AlertTypeDTO[]>>('/secured/user/product/notification/read')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {
    getCreditReports,
    getCreditReportByDate,
    getNotificationsMetadata,
    getNotifications,
    getNotificationDetails,
    readNotification,
    clearNotification,
};
